import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import PostList, {
    PropsFromDispatch,
    PropsFromState,
} from '../components/PostList';
import {
    RootState,
    selectMediaPage,
} from '../store';

export const mapStateToProps = (
    state: RootState
): PropsFromState => ({
    postRows: selectMediaPage(state)
});

export const mapDispatchToProps = (
    dispatch: Dispatch
): PropsFromDispatch => ({
});

export default connect(mapStateToProps, mapDispatchToProps)
    (PostList);
